"use client";

import { OpenFeatureProvider } from "@openfeature/react-sdk";

export function OpenFeatureWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return <OpenFeatureProvider>{children}</OpenFeatureProvider>;
}
